module.exports = __webpack_public_path__ + "static/HSE_6M_2020_2021_Bondholder_Reporting-86d16a312c1def0c56c3828c09c876d4.pdf";